import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'core/stores/StoreContext';
import { DatePickerTemplate } from 'themes/components';

const DatePicker = observer((props) => {
    const { timeZoneStore } = useStores();
    return <DatePickerTemplate {...props} timeZone={timeZoneStore.timeZone} />;
});

export default DatePicker;
